export class ChangePin{
    oldPin: string;
    newPin: string;
    newPinRepeat: string;
    otpCode: string;
    refNo: string;

    constructor(oldPin: string, newPin: string, newPinRepeat: string, otpCode: string, refNo: string){
        this.oldPin = oldPin;
        this.newPin = newPin;
        this.newPinRepeat = newPinRepeat;
        this.otpCode = otpCode;
        this.refNo = refNo;
    }
}